var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.308 20h2.243c.856 0 1.308-.424 1.308-1.234V6.225c0-.838-.452-1.225-1.308-1.225H7.308C6.452 5 6 5.424 6 6.225v12.541C6 19.576 6.452 20 7.308 20Zm7.151 0h2.233c.865 0 1.308-.424 1.308-1.234V6.225C18 5.387 17.557 5 16.692 5h-2.233c-.866 0-1.318.424-1.318 1.225v12.541c0 .81.452 1.234 1.318 1.234Z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgPause);
export default Memo;